module.exports = __webpack_public_path__ + "img/product_0_3.49ecb4b0.jpg";